const StatsPanel = ({ stats }) => {
  const cards = [
    { key: 'total', label: 'Total Games', value: stats.total, accent: 'text-white' },
    { key: 'live', label: 'Live', value: stats.live, accent: 'text-emerald-400', indicator: 'bg-emerald-400 animate-pulse' },
    { key: 'upcoming', label: 'Upcoming', value: stats.upcoming, accent: 'text-violet-400' },
    { key: 'finished', label: 'Finished', value: stats.finished, accent: 'text-white/70' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.key}
          className="border border-white/10 rounded-sm p-4 bg-white/[0.02] hover:border-white/40 transition-colors"
        >
          <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-gray-500 mb-3 flex items-center gap-2">
            {card.indicator && <span className={`w-2 h-2 rounded-full ${card.indicator}`} />}
            {card.label}
          </p>
          <p className={`font-black text-3xl tabular-nums ${card.accent}`}>{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;
